import React from 'react';
import PropTypes from 'prop-types';
import ReactDropzone from 'react-dropzone';

export class DropZone extends React.PureComponent {
	static propTypes = {
		children: PropTypes.func,
		className: PropTypes.string,
		disabled: PropTypes.bool,
		name: PropTypes.string.isRequired,
		onChange: PropTypes.func.isRequired,
	};

	state = {
		file: null,
	};

	onDrop = files => {
		const file = files && files.length === 1 ? files[0] : null;

		this.onChange(file);
	};

	onChange = (file = null) => {
		this.setState({ file });

		this.props.onChange({
			currentTarget: {
				files: file ? [file] : [],
			},
		});
	};

	clearFile = e => {
		e.preventDefault();

		this.onChange();
	};

	render() {
		const { children, className, disabled, name } = this.props;
		const { file } = this.state;

		return (
			<ReactDropzone
				className={className}
				disabled={disabled || !!file}
				name={name}
				multiple={false}
				onDrop={this.onDrop}
			>
				{children && children(file, this.clearFile)}
			</ReactDropzone>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/shared/dropZone/component.js